import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './CategoryPage.css';

// Hero video
import heroVideo from '../../assets/gallery/product-category-page.mp4';

// Smart Home Hub images
import hubM200 from '../../assets/smarthubs/hub-m200-transparent-2.png';
import hubM100 from '../../assets/smarthubs/hub-m100-product-picture-1.png';
import hubM3 from '../../assets/smarthubs/M3-分类页白底图-2048x2048.png';
import hubM2 from '../../assets/smarthubs/Hub-M2.png';
import hubE1 from '../../assets/smarthubs/HUBE1.png';
import hubM1SGen2 from '../../assets/smarthubs/Hub-M1S-Gen-2.png';
import cameraHubG2H from '../../assets/smarthubs/camera-hub-g2h-1.png';
import aqaraHub1 from '../../assets/smarthubs/aqara-hub-1.png';
import aqaraHub1Alt from '../../assets/smarthubs/aqara-hub-1 (1).png';
import cameraHubG2HPro from '../../assets/smarthubs/Camera-Hub-G2H-Pro.png';
import cameraHubG3Hub from '../../assets/smarthubs/Camera-Hub-G3.png';

// Smart Door Lock images
import smartLockB50 from '../../assets/smartdoorlocks/Smart Lock B50.png';
import smartLockU200Lite from '../../assets/smartdoorlocks/Smart Lock U200 Lite.png';
import smartLockU300 from '../../assets/smartdoorlocks/Smart Lock U300.png';
import smartLockU200 from '../../assets/smartdoorlocks/Smart Lock U200.png';
import smartLockU50 from '../../assets/smartdoorlocks/Smart Lock U50.png';
import smartLockU100 from '../../assets/smartdoorlocks/Smart Lock U100.png';
import smartLockD200i from '../../assets/smartdoorlocks/Smart Lock D200i.jpg';
import smartLockU400 from '../../assets/smartdoorlocks/smart Lock U400.png';
import smartLockA100 from '../../assets/smartdoorlocks/Smart-Door-Lock-A100-Zigbee.png';
import smartLockD100 from '../../assets/smartdoorlocks/Smart-Door-Lock-D100-Zigbee.png';
import smartLockN100 from '../../assets/smartdoorlocks/Smart-Door-Lock-N100-Zigbee.png';

// Smart Sensor images
import presenceFP300 from '../../assets/smartsensors/Presence Multi-Sensor FP300.png';
import vibrationT1 from '../../assets/smartsensors/Vibration Sensor T1.jpg';
import climateW100 from '../../assets/smartsensors/Climate Sensor W100.png';
import presenceFP1E from '../../assets/smartsensors/Presence Sensor FP1E.png';
import motionLightP2 from '../../assets/smartsensors/Motion and Light Sensor P2.png';
import doorWindowP2 from '../../assets/smartsensors/Door and Window Sensor P2.png';
import presenceFP2 from '../../assets/smartsensors/Presence Sensor FP2.png';
import motionP1 from '../../assets/smartsensors/Motion Sensor P1.png';
import waterLeak from '../../assets/smartsensors/Water Leak Sensor.png';
import tempHumidity from '../../assets/smartsensors/Temperature and Humidity Sensor.png';
import doorWindowT1 from '../../assets/smartsensors/Door and Window Sensor T1.png';
import doorWindowSensor from '../../assets/smartsensors/Door-and-Window-Sensor.png';
import motionSensor from '../../assets/smartsensors/Motion Sensor.png';
import smartGasDetector from '../../assets/smartsensors/Smart Gas Detector.png';
import tempHumidityT1 from '../../assets/smartsensors/Temperature and Humidity Sensor T1.png';
import tvocAirQuality from '../../assets/smartsensors/TVOC Air Quality Monitor.png';
import vibrationSensor from '../../assets/smartsensors/Vibration Sensor.png';
import waterLeakT1 from '../../assets/smartsensors/Water Leak Sensor T1.png';

// Smart Controller images
import wallSwitchH2 from '../../assets/smartcontrollers/Light Switch H2 US.png';
import wirelessH1 from '../../assets/smartcontrollers/Wireless Remote Switch H1.png';
import cubeT1Pro from '../../assets/smartcontrollers/Cube T1 Pro.png';
import smartPlug from '../../assets/smartcontrollers/Smart Plug(US Version).png';
import cube from '../../assets/smartcontrollers/Cube.png';
import dimmerH2EU from '../../assets/smartcontrollers/Dimmer Switch H2 EU.jpg';
import dimmerH2US from '../../assets/smartcontrollers/Dimmer Switch H2 US.png';
import displaySwitchV1 from '../../assets/smartcontrollers/Display Switch V1 EU.jpg';
import dualRelayT2 from '../../assets/smartcontrollers/Dual Relay Module T2.png';
import floorHeatingW500 from '../../assets/smartcontrollers/Floor Heating Thermostat W500.png';
import lightSwitchH2EU from '../../assets/smartcontrollers/Light Switch H2 EU.jpg';
import lightSwitchH2Horiz from '../../assets/smartcontrollers/Light Switch H2 Horizontal.png';
import magicSwitchS1E from '../../assets/smartcontrollers/Magic Switch S1E.png';
import magicPadS1Plus from '../../assets/smartcontrollers/MagicPad S1 Plus (SEA&ME Version).png';
import panelHubS1Plus from '../../assets/smartcontrollers/Panel Hub S1 Plus.jpg';
import panelSwitchS100 from '../../assets/smartcontrollers/Panel Switch S100.jpg';
import radiatorE1 from '../../assets/smartcontrollers/Radiator Thermostat E1.png';
import radiatorW600 from '../../assets/smartcontrollers/Radiator Thermostat W600.png';
import shutterH2EU from '../../assets/smartcontrollers/Shutter Switch H2 EU.png';
import singleSwitchT1NoNeutral from '../../assets/smartcontrollers/Single Switch Module T1 (No Neutral).png';
import singleSwitchT1WithNeutral from '../../assets/smartcontrollers/Single Switch Module T1 (With Neutral).png';
import smart20ASwitch from '../../assets/smartcontrollers/Smart 20A Switch H1 (SEA Version）.png';
import smartPetFeeder from '../../assets/smartcontrollers/Smart Pet Feeder C1.png';
import smartPlugEU from '../../assets/smartcontrollers/Smart-PlugEU-Version.png';
import smartWallSwitchNoNeutral from '../../assets/smartcontrollers/Smart Wall Switch (No Neutral).png';
import smartWallSwitchWithNeutral from '../../assets/smartcontrollers/Smart Wall Switch (With Neutral).png';
import smartWallSwitchH1EUNoNeutral from '../../assets/smartcontrollers/Smart Wall Switch H1 EU (No Neutral).png';
import smartWallSwitchH1EUWithNeutral from '../../assets/smartcontrollers/Smart Wall Switch H1 EU (With Neutral).png';
import smartWallSwitchH1EUGrey from '../../assets/smartcontrollers/Smart Wall Switch H1 EU(No Neutral) - Grey.png';
import smartWallSwitchH1TripleNoNeutral from '../../assets/smartcontrollers/Smart Wall Switch H1 Triple Rocker (No Neutral).png';
import smartWallSwitchH1TripleWithNeutral from '../../assets/smartcontrollers/Smart Wall Switch H1 Triple Rocker (With Neutral).png';
import smartWallSwitchZ1Pro from '../../assets/smartcontrollers/Smart Wall Switch Z1 Pro.png';
import thermostatW400 from '../../assets/smartcontrollers/Thermostat W400.png';
import touchscreenDialV1 from '../../assets/smartcontrollers/Touchscreen Dial V1 EU.jpg';
import valveControllerT1 from '../../assets/smartcontrollers/Valve Controller T1.jpg';
import wallOutletH2EU from '../../assets/smartcontrollers/Wall Outlet H2 EU.jpg';
import wallOutletH2UK from '../../assets/smartcontrollers/Wall Outlet H2 UK.png';
import wirelessMiniSwitchT1 from '../../assets/smartcontrollers/Wireless Mini Switch T1.png';
import wirelessMiniSwitch from '../../assets/smartcontrollers/Wireless Mini Switch.png';

// Smart Camera images
import doorbellG410 from '../../assets/smartcameras/Doorbell Camera Hub G410.png';
import cameraG100 from '../../assets/smartcameras/Camera G100.png';
import cameraY100 from '../../assets/smartcameras/Camera Protect Kit Y100.jpg';
import cameraG5Pro from '../../assets/smartcameras/Camera Hub G5 Pro.jpg';
import cameraE1 from '../../assets/smartcameras/Camera E1.png';
import doorbellG4 from '../../assets/smartcameras/Smart Video Doorbell G4.png';
import cameraG3 from '../../assets/smartcameras/Camera Hub G3.png';
import cameraG2HPro from '../../assets/smartcameras/Camera Hub G2H Pro.png';
import cameraG2H from '../../assets/smartcameras/Camera Hub G2H.png';

// Smart Lighting images
import ledBulbT2 from '../../assets/smartlights/LED Bulb T2.png';
import ledStripT1 from '../../assets/smartlights/LED Strip T1.webp';
import ledBulbT1 from '../../assets/smartlights/LED Bulb T1.png';
import ceilingT1M from '../../assets/smartlights/Ceiling Light T1M.png';
import spotlightT1 from '../../assets/smartlights/Spotlight T1.jpg';
import ledBulbTunableWhite from '../../assets/smartlights/LED Light Bulb (Tunable White).png';
import spotlightT2Lite from '../../assets/smartlights/Spotlight T2 Lite.png';
import spotlightT2Pro from '../../assets/smartlights/Spotlight T2 Pro.png';
import spotlightV1 from '../../assets/smartlights/Spotlight V1.png';
import trackFloodlightV1 from '../../assets/smartlights/Track Floodlight V1.png';
import trackGrilleLightV1 from '../../assets/smartlights/Track Grille Light V1.png';
import trackSpotlightV1 from '../../assets/smartlights/Track Spotlight V1.png';

// Smart Curtain images
import curtainC3 from '../../assets/smartcurtain/Curtain Controller C3.jpg';
import curtainSEA from '../../assets/smartcurtain/Curtain Controller(SEA Version).png';
import curtainE1Rod from '../../assets/smartcurtain/Curtain Driver E1 (Rod Version).png';
import curtainE1Track from '../../assets/smartcurtain/Curtain Driver E1 (Track Version).png';
import rollerT1S from '../../assets/smartcurtain/Roller Shade Controller T1S.jpg';
import rollerE1 from '../../assets/smartcurtain/Roller Shade Driver E1.png';
import rollerController from '../../assets/smartcurtain/Smart Roller Shade Controller.png';

interface Product {
  id: string;
  name: string;
  image: string;
  description: string;
  badges?: string[];
}

interface CategoryData {
  name: string;
  description: string;
  heroImage: string;
  products: Product[];
}

const CategoryPage: React.FC = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const [viewMode, setViewMode] = useState<'grid-2' | 'grid-3' | 'list'>('grid-3');

  // Scroll to top when category changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [categoryId]);

  // Dummy data for different categories
  const categoryData: { [key: string]: CategoryData } = {
    'smart-home-hub': {
      name: 'Smart Home Hub',
      description: 'Central devices that connect and control various smart home products, allowing them to work together seamlessly.',
      heroImage: hubM200,
      products: [
        { id: 'hub-m200', name: 'Hub M200', image: hubM200, description: 'One Hub. Matter & IR Control', badges: ['Best Seller', 'Matter'] },
        { id: 'hub-m100', name: 'Hub M100', image: hubM100, description: 'Mighty Hub, Minimal Size', badges: ['NEW'] },
        { id: 'hub-m3', name: 'Hub M3', image: hubM3, description: 'Continuous Connectivity for Your Smart Devices', badges: ['Aqara', 'Matter'] },
        { id: 'hub-m2', name: 'Hub M2', image: hubM2, description: 'Central Hub with Built-in Speaker' },
        { id: 'camera-hub-g3', name: 'Camera Hub G3', image: cameraHubG3Hub, description: '2K Camera with Built-in Zigbee Hub', badges: ['Aqara'] },
        { id: 'camera-hub-g2h-pro', name: 'Camera Hub G2H Pro', image: cameraHubG2HPro, description: '1080p Camera with Zigbee Hub', badges: ['Aqara'] },
        { id: 'hub-e1', name: 'Hub E1', image: hubE1, description: 'Compact USB-Powered Hub' },
        { id: 'hub-m1s-gen-2', name: 'Hub M1S Gen 2', image: hubM1SGen2, description: 'Advanced Zigbee Hub', badges: ['Aqara'] },
        { id: 'camera-hub-g2h', name: 'Camera Hub G2H', image: cameraHubG2H, description: 'HomeKit Secure Video Hub' },
        { id: 'aqara-hub', name: 'Aqara Hub', image: aqaraHub1, description: 'Classic Aqara Gateway for Smart Home' }
      ]
    },
    'smart-door-locks': {
      name: 'Smart Door Locks',
      description: 'Secure and access your home using digital methods like fingerprint, password, and mobile app control.',
      heroImage: smartLockU100,
      products: [
        { id: 'smart-lock-b50', name: 'Smart Lock B50', image: smartLockB50, description: 'Remotely Controllable Lock Made Simple', badges: ['NEW', 'Best Seller'] },
        { id: 'smart-lock-u200-lite', name: 'Smart Lock U200 Lite', image: smartLockU200Lite, description: 'Smart Security for Classic Doors', badges: ['NEW'] },
        { id: 'smart-lock-u300', name: 'Smart Lock U300', image: smartLockU300, description: 'A Smarter Handle on Home Security', badges: ['Aqara'] },
        { id: 'smart-lock-u200', name: 'Smart Lock U200', image: smartLockU200, description: 'Ultimate Smart Lock Retrofitted for You', badges: ['Matter'] },
        { id: 'smart-lock-u50', name: 'Smart Lock U50', image: smartLockU50, description: 'The Complete Smart Lock for Every Home', badges: ['Aqara'] },
        { id: 'smart-lock-u100', name: 'Smart Lock U100', image: smartLockU100, description: 'Premium Smart Lock with Multiple Access Methods' },
        { id: 'smart-lock-d200i', name: 'Smart Lock D200i', image: smartLockD200i, description: 'Advanced Facial Recognition Door Lock', badges: ['NEW'] },
        { id: 'smart-lock-u400', name: 'Smart Lock U400', image: smartLockU400, description: 'Ultra-Secure Smart Lock with Advanced Features', badges: ['Aqara'] },
        { id: 'smart-lock-a100', name: 'Smart Lock A100', image: smartLockA100, description: 'Zigbee-Enabled Smart Door Lock', badges: ['Zigbee'] },
        { id: 'smart-lock-d100', name: 'Smart Lock D100', image: smartLockD100, description: 'Durable Zigbee Smart Lock', badges: ['Zigbee'] },
        { id: 'smart-lock-n100', name: 'Smart Lock N100', image: smartLockN100, description: 'Next-Gen Zigbee Door Lock', badges: ['Zigbee'] }
      ]
    },
    'smart-home-sensor': {
      name: 'Smart Home Sensor',
      description: 'Monitor motion, temperature, humidity, door/window status, and more with intelligent sensors.',
      heroImage: presenceFP300,
      products: [
        { id: 'presence-multi-sensor-fp300', name: 'Presence Multi-Sensor FP300', image: presenceFP300, description: 'Wireless Sensor with 5-in-1 Detection Capability', badges: ['NEW', 'Best Seller'] },
        { id: 'vibration-sensor-t1', name: 'Vibration Sensor T1', image: vibrationT1, description: 'Detects Abnormal Movements, Tilts, and Drops', badges: ['Aqara'] },
        { id: 'climate-sensor-w100', name: 'Climate Sensor W100', image: climateW100, description: 'Precise Sensor with LCD Display' },
        { id: 'presence-sensor-fp1e', name: 'Presence Sensor FP1E', image: presenceFP1E, description: 'Precise Detection for Optimal Spaces', badges: ['Aqara'] },
        { id: 'motion-light-sensor-p2', name: 'Motion and Light Sensor P2', image: motionLightP2, description: 'Native Matter Support', badges: ['Matter'] },
        { id: 'door-window-sensor-p2', name: 'Door and Window Sensor P2', image: doorWindowP2, description: 'Ultra-Compact Design', badges: ['Aqara', 'Matter'] },
        { id: 'presence-sensor-fp2', name: 'Presence Sensor FP2', image: presenceFP2, description: 'Advanced mmWave Radar Technology', badges: ['Best Seller'] },
        { id: 'motion-sensor-p1', name: 'Motion Sensor P1', image: motionP1, description: 'High Precision Motion Detection' },
        { id: 'water-leak-sensor', name: 'Water Leak Sensor', image: waterLeak, description: 'Early Water Leak Detection', badges: ['Aqara'] },
        { id: 'temp-humidity-sensor', name: 'Temperature & Humidity Sensor', image: tempHumidity, description: 'Swiss-Made Sensors for Accurate Monitoring' },
        { id: 'door-window-sensor-t1', name: 'Door and Window Sensor T1', image: doorWindowT1, description: 'Reliable Door and Window Monitoring', badges: ['Aqara'] },
        { id: 'door-window-sensor', name: 'Door and Window Sensor', image: doorWindowSensor, description: 'Classic Contact Sensor for Home Security' },
        { id: 'motion-sensor', name: 'Motion Sensor', image: motionSensor, description: 'Intelligent Motion Detection System' },
        { id: 'smart-gas-detector', name: 'Smart Gas Detector', image: smartGasDetector, description: 'Gas Leak Detection and Alert System', badges: ['Safety'] },
        { id: 'temp-humidity-sensor-t1', name: 'Temperature & Humidity Sensor T1', image: tempHumidityT1, description: 'Accurate Environmental Monitoring', badges: ['Aqara'] },
        { id: 'tvoc-air-quality', name: 'TVOC Air Quality Monitor', image: tvocAirQuality, description: 'Monitor Indoor Air Quality in Real-Time', badges: ['Health'] },
        { id: 'vibration-sensor', name: 'Vibration Sensor', image: vibrationSensor, description: 'Detect Vibrations and Movements' },
        { id: 'water-leak-sensor-t1', name: 'Water Leak Sensor T1', image: waterLeakT1, description: 'Advanced Water Leak Prevention', badges: ['Aqara'] }
      ]
    },
    'smart-home-controller': {
      name: 'Smart Home Controller',
      description: 'Control your lights, appliances, and other devices with smart switches and controllers.',
      heroImage: wallSwitchH2,
      products: [
        { id: 'light-switch-h2-us', name: 'Light Switch H2 US', image: wallSwitchH2, description: 'Matter-Enabled Wall Switch', badges: ['Aqara', 'Matter'] },
        { id: 'cube-t1-pro', name: 'Cube T1 Pro', image: cubeT1Pro, description: 'Six-Sided Controller', badges: ['Best Seller'] },
        { id: 'smart-plug', name: 'Smart Plug (US)', image: smartPlug, description: 'Smart Power Control', badges: ['Aqara'] },
        { id: 'cube', name: 'Cube', image: cube, description: 'Innovative Gesture Controller' },
        { id: 'dimmer-switch-h2-eu', name: 'Dimmer Switch H2 EU', image: dimmerH2EU, description: 'European Dimmer Switch', badges: ['Aqara'] },
        { id: 'dimmer-switch-h2-us', name: 'Dimmer Switch H2 US', image: dimmerH2US, description: 'US Standard Dimmer Switch', badges: ['Aqara'] },
        { id: 'dual-relay-module-t2', name: 'Dual Relay Module T2', image: dualRelayT2, description: 'Control Two Devices Independently' },
        { id: 'floor-heating-thermostat-w500', name: 'Floor Heating Thermostat W500', image: floorHeatingW500, description: 'Smart Floor Heating Control', badges: ['Aqara'] },

        { id: 'radiator-thermostat-e1', name: 'Radiator Thermostat E1', image: radiatorE1, description: 'Smart Radiator Temperature Control', badges: ['Aqara'] },
        { id: 'radiator-thermostat-w600', name: 'Radiator Thermostat W600', image: radiatorW600, description: 'Advanced Radiator Control' },
        { id: 'shutter-switch-h2-eu', name: 'Shutter Switch H2 EU', image: shutterH2EU, description: 'Smart Shutter and Blind Control', badges: ['Aqara'] },
        { id: 'single-switch-module-t1-no-neutral', name: 'Single Switch Module T1 (No Neutral)', image: singleSwitchT1NoNeutral, description: 'Compact Switch Without Neutral Wire' },
        { id: 'single-switch-module-t1-with-neutral', name: 'Single Switch Module T1 (With Neutral)', image: singleSwitchT1WithNeutral, description: 'Switch Module With Neutral Wire' },
        { id: 'smart-20a-switch-h1-sea', name: 'Smart 20A Switch H1', image: smart20ASwitch, description: 'High-Power Smart Switch', badges: ['Aqara'] },
        { id: 'smart-pet-feeder-c1', name: 'Smart Pet Feeder C1', image: smartPetFeeder, description: 'Automated Pet Feeding System', badges: ['NEW', 'Pet Care'] },
        { id: 'smart-plug-eu', name: 'Smart Plug (EU)', image: smartPlugEU, description: 'European Smart Plug', badges: ['Aqara'] },
        { id: 'smart-wall-switch-no-neutral', name: 'Smart Wall Switch (No Neutral)', image: smartWallSwitchNoNeutral, description: 'Wall Switch for Homes Without Neutral' },
        { id: 'smart-wall-switch-with-neutral', name: 'Smart Wall Switch (With Neutral)', image: smartWallSwitchWithNeutral, description: 'Standard Wall Switch' },
        { id: 'smart-wall-switch-h1-eu-no-neutral', name: 'Smart Wall Switch H1 EU (No Neutral)', image: smartWallSwitchH1EUNoNeutral, description: 'European Switch Without Neutral', badges: ['Aqara'] },
        { id: 'thermostat-w400', name: 'Thermostat W400', image: thermostatW400, description: 'Smart Climate Control', badges: ['Aqara'] },
        { id: 'valve-controller-t1', name: 'Valve Controller T1', image: valveControllerT1, description: 'Smart Water Valve Control', badges: ['Aqara'] },
        { id: 'wall-outlet-h2-eu', name: 'Wall Outlet H2 EU', image: wallOutletH2EU, description: 'Smart Wall Socket European', badges: ['Aqara'] },
        { id: 'wall-outlet-h2-uk', name: 'Wall Outlet H2 UK', image: wallOutletH2UK, description: 'Smart Wall Socket UK Standard' },
        { id: 'wireless-mini-switch-t1', name: 'Wireless Mini Switch T1', image: wirelessMiniSwitchT1, description: 'Compact Wireless Switch', badges: ['Aqara'] },
        { id: 'wireless-mini-switch', name: 'Wireless Mini Switch', image: wirelessMiniSwitch, description: 'Portable Mini Controller' }
      ]
    },
    'switches': {
      name: 'Smart Switches',
      description: 'Smart wall switches and touch panels for modern lighting control.',
      heroImage: touchscreenDialV1,
      products: [
        { id: 'touchscreen-dial-v1-eu', name: 'Touchscreen Dial V1 EU', image: touchscreenDialV1, description: 'Rotary Touch Control Panel', badges: ['NEW'] },
        { id: 'smart-wall-switch-h1-triple-neutral', name: 'Smart Wall Switch H1 Triple (With Neutral)', image: smartWallSwitchH1TripleWithNeutral, description: 'Triple Gang Switch With Neutral' },
        { id: 'smart-wall-switch-z1-pro', name: 'Smart Wall Switch Z1 Pro', image: smartWallSwitchZ1Pro, description: 'Professional Smart Wall Switch', badges: ['Pro'] },
        { id: 'smart-wall-switch-h1-eu-neutral', name: 'Smart Wall Switch H1 EU (With Neutral)', image: smartWallSwitchH1EUWithNeutral, description: 'European Switch With Neutral', badges: ['Aqara'] },
        { id: 'smart-wall-switch-h1-eu-grey', name: 'Smart Wall Switch H1 EU Grey', image: smartWallSwitchH1EUGrey, description: 'Grey Finish European Switch' },
        { id: 'smart-wall-switch-h1-triple-no-neutral', name: 'Smart Wall Switch H1 Triple (No Neutral)', image: smartWallSwitchH1TripleNoNeutral, description: 'Triple Gang Switch Without Neutral' },
        { id: 'panel-switch-s100', name: 'Panel Switch S100', image: panelSwitchS100, description: 'Elegant Touch Panel Switch' },
        { id: 'magic-switch-s1e', name: 'Magic Switch S1E', image: magicSwitchS1E, description: 'Versatile Smart Switch Solution', badges: ['NEW'] },
        { id: 'magicpad-s1-plus', name: 'MagicPad S1 Plus', image: magicPadS1Plus, description: 'Advanced Touch Control Panel', badges: ['Best Seller'] },
        { id: 'panel-hub-s1-plus', name: 'Panel Hub S1 Plus', image: panelHubS1Plus, description: 'Central Control Panel with Hub', badges: ['Aqara'] },
        { id: 'light-switch-h2-eu', name: 'Light Switch H2 EU', image: lightSwitchH2EU, description: 'European Light Switch', badges: ['Aqara'] },
        { id: 'wireless-remote-switch-h1', name: 'Wireless Remote Switch H1', image: wirelessH1, description: 'Battery-Powered Wireless Control' }
      ]
    },
    'smart-cameras': {
      name: 'Smart Cameras',
      description: 'Monitor your home with intelligent security cameras featuring AI detection and cloud storage.',
      heroImage: doorbellG410,
      products: [
        { id: 'doorbell-camera-hub-g410', name: 'Doorbell Camera Hub G410', image: doorbellG410, description: 'The Smartest Way to Say Hello', badges: ['NEW', 'Best Seller'] },
        { id: 'camera-g100', name: 'Camera G100', image: cameraG100, description: 'Secure Inside and Out', badges: ['NEW'] },
        { id: 'camera-protect-kit-y100', name: 'Camera Protect Kit Y100', image: cameraY100, description: 'Unparalleled Smart Home Security Plan', badges: ['NEW'] },
        { id: 'camera-hub-g5-pro', name: 'Camera Hub G5 Pro', image: cameraG5Pro, description: 'Clearly Capturing the Unexpected, Day and Night', badges: ['Aqara'] },
        { id: 'camera-e1', name: 'Camera E1', image: cameraE1, description: 'Smart Vision for a Safer Home' },
        { id: 'smart-video-doorbell-g4', name: 'Smart Video Doorbell G4', image: doorbellG4, description: 'Always Around, Even When You\'re Not', badges: ['Aqara'] },
        { id: 'camera-hub-g3', name: 'Camera Hub G3', image: cameraG3, description: '2K Camera with Zigbee Hub' },
        { id: 'camera-hub-g2h-pro', name: 'Camera Hub G2H Pro', image: cameraG2HPro, description: '1080p HD Camera with Hub', badges: ['Aqara'] },
        { id: 'camera-hub-g2h', name: 'Camera Hub G2H', image: cameraG2H, description: 'HomeKit Secure Video Compatible Camera', badges: ['HomeKit'] }
      ]
    },
    'smart-lighting': {
      name: 'Smart Lighting',
      description: 'Control brightness, color, and schedule your lights from anywhere with smart LED bulbs.',
      heroImage: ledBulbT2,
      products: [
        { id: 'led-bulb-t2', name: 'LED Bulb T2', image: ledBulbT2, description: 'Tunable White Smart Bulb', badges: ['NEW', 'Aqara'] },
        { id: 'led-strip-t1', name: 'LED Strip T1', image: ledStripT1, description: 'Flexible RGB+W LED Strip', badges: ['Best Seller'] },
        { id: 'led-bulb-t1', name: 'LED Bulb T1', image: ledBulbT1, description: 'Energy Efficient Smart Bulb', badges: ['Aqara'] },
        { id: 'ceiling-light-t1m', name: 'Ceiling Light T1M', image: ceilingT1M, description: 'Modern Smart Ceiling Light' },
        { id: 'spotlight-t1', name: 'Spotlight T1', image: spotlightT1, description: 'GU10 Smart Spotlight' },
        { id: 'led-bulb-tunable-white', name: 'LED Light Bulb (Tunable White)', image: ledBulbTunableWhite, description: 'Adjustable Color Temperature Bulb', badges: ['Aqara'] },
        { id: 'spotlight-t2-lite', name: 'Spotlight T2 Lite', image: spotlightT2Lite, description: 'Affordable Smart Spotlight', badges: ['NEW'] },
        { id: 'spotlight-t2-pro', name: 'Spotlight T2 Pro', image: spotlightT2Pro, description: 'Professional Smart Spotlight', badges: ['Pro'] },
        { id: 'spotlight-v1', name: 'Spotlight V1', image: spotlightV1, description: 'Versatile Smart Spotlight' },
        { id: 'track-floodlight-v1', name: 'Track Floodlight V1', image: trackFloodlightV1, description: 'Track-Mounted Floodlight', badges: ['NEW'] },
        { id: 'track-grille-light-v1', name: 'Track Grille Light V1', image: trackGrilleLightV1, description: 'Track Grille Lighting Solution' },
        { id: 'track-spotlight-v1', name: 'Track Spotlight V1', image: trackSpotlightV1, description: 'Track System Spotlight' }
      ]
    },
    'smart-curtain': {
      name: 'Smart Curtain',
      description: 'Automate your curtains and shades with motorized controllers for convenience and energy efficiency.',
      heroImage: curtainE1Track,
      products: [
        { id: 'curtain-controller-c3', name: 'Curtain Controller C3', image: curtainC3, description: 'Advanced Curtain Automation', badges: ['NEW', 'Best Seller'] },
        { id: 'curtain-controller-sea', name: 'Curtain Controller (SEA Version)', image: curtainSEA, description: 'Regional Curtain Control Solution', badges: ['Aqara'] },
        { id: 'curtain-driver-e1-rod', name: 'Curtain Driver E1 (Rod Version)', image: curtainE1Rod, description: 'Perfect for Rod-style Curtains' },
        { id: 'curtain-driver-e1-track', name: 'Curtain Driver E1 (Track Version)', image: curtainE1Track, description: 'Ideal for Track Curtains', badges: ['Aqara'] },
        { id: 'roller-shade-t1s', name: 'Roller Shade Controller T1S', image: rollerT1S, description: 'Smart Roller Shade Control', badges: ['Best Seller'] },
        { id: 'roller-shade-e1', name: 'Roller Shade Driver E1', image: rollerE1, description: 'Compact Roller Shade Motor' },
        { id: 'roller-shade-controller', name: 'Smart Roller Shade Controller', image: rollerController, description: 'Intelligent Shade Management' }
      ]
    }
  };

  const category = categoryId ? categoryData[categoryId] : null;

  if (!category) {
    return (
      <>
        <Header />
        <div className="category-page">
          <div className="category-container">
            <h1>Category not found</h1>
            <Link to="/" className="back-btn">Back to Home</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="category-page">
        {/* Hero Banner */}
        <div className="category-hero">
          <video 
            className="category-hero-video"
            autoPlay 
            loop 
            muted 
            playsInline
          >
            <source src={heroVideo} type="video/mp4" />
          </video>
          <div className="category-hero-overlay">
            <h1 className="category-hero-title">{category.name}</h1>
          </div>
        </div>

        {/* Main Content */}
        <div className="category-main">
          {/* Sidebar */}
          <aside className="category-sidebar">
            {/* Categories Navigation */}
            <div className="sidebar-section categories-nav">
              <h3 className="sidebar-title">Categories</h3>
              <div className="category-list">
                <Link 
                  to="/category/smart-home-hub" 
                  className={`category-nav-item ${categoryId === 'smart-home-hub' ? 'active' : ''}`}
                >
                  Smart Home Hub
                </Link>
                <Link 
                  to="/category/smart-door-locks" 
                  className={`category-nav-item ${categoryId === 'smart-door-locks' ? 'active' : ''}`}
                >
                  Smart Door Locks
                </Link>
                <Link 
                  to="/category/smart-home-sensor" 
                  className={`category-nav-item ${categoryId === 'smart-home-sensor' ? 'active' : ''}`}
                >
                  Smart Home Sensor
                </Link>
                <Link 
                  to="/category/smart-home-controller" 
                  className={`category-nav-item ${categoryId === 'smart-home-controller' ? 'active' : ''}`}
                >
                  Smart Home Controller
                </Link>
                <Link 
                  to="/category/switches" 
                  className={`category-nav-item ${categoryId === 'switches' ? 'active' : ''}`}
                >
                  Smart Switches
                </Link>
                <Link 
                  to="/category/smart-cameras" 
                  className={`category-nav-item ${categoryId === 'smart-cameras' ? 'active' : ''}`}
                >
                  Smart Cameras
                </Link>
                <Link 
                  to="/category/smart-lighting" 
                  className={`category-nav-item ${categoryId === 'smart-lighting' ? 'active' : ''}`}
                >
                  Smart Lighting
                </Link>
                <Link 
                  to="/category/smart-curtain" 
                  className={`category-nav-item ${categoryId === 'smart-curtain' ? 'active' : ''}`}
                >
                  Smart Curtain
                </Link>
              </div>
            </div>
          </aside>

          {/* Products Grid */}
          <div className="category-content">
            <div className="category-header-bar">
              <h2 className="category-title-main">{category.name}</h2>
              <div className="header-right">
                <span className="product-count-badge">{category.products.length} Products</span>
                <div className="view-controls">
                  <button 
                    className={`view-btn ${viewMode === 'grid-2' ? 'active' : ''}`}
                    onClick={() => setViewMode('grid-2')}
                    title="2 columns"
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <rect x="2" y="2" width="7" height="7" />
                      <rect x="11" y="2" width="7" height="7" />
                      <rect x="2" y="11" width="7" height="7" />
                      <rect x="11" y="11" width="7" height="7" />
                    </svg>
                  </button>
                  <button 
                    className={`view-btn ${viewMode === 'grid-3' ? 'active' : ''}`}
                    onClick={() => setViewMode('grid-3')}
                    title="3 columns"
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <rect x="1" y="2" width="5" height="5" />
                      <rect x="7.5" y="2" width="5" height="5" />
                      <rect x="14" y="2" width="5" height="5" />
                      <rect x="1" y="8.5" width="5" height="5" />
                      <rect x="7.5" y="8.5" width="5" height="5" />
                      <rect x="14" y="8.5" width="5" height="5" />
                    </svg>
                  </button>
                  <button 
                    className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                    onClick={() => setViewMode('list')}
                    title="list"
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <rect x="2" y="3" width="16" height="3" />
                      <rect x="2" y="8.5" width="16" height="3" />
                      <rect x="2" y="14" width="16" height="3" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className={`products-grid view-${viewMode}`}>
              {category.products.map((product) => (
                <Link 
                  key={product.id} 
                  to={`/product/${product.id}`} 
                  className="product-card"
                >
                  {product.badges && product.badges.length > 0 && (
                    <div className="product-badges">
                      {product.badges.map((badge, index) => (
                        <span key={index} className={`badge ${badge.toLowerCase().replace(' ', '-')}`}>
                          {badge}
                        </span>
                      ))}
                    </div>
                  )}
                  <div className="product-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="product-info">
                    <h3 className="product-name">{product.name}</h3>
                    <p className="product-description">{product.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CategoryPage;
